import cn from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Table from 'components/shared/table';
import LinkButton from 'components/shared/LinkButton';
import {
  localTime,
  localTimeZone,
} from 'components/InPersonTraining/shared/LocalTimeAndTimeZone';
import DateFormat from 'constants/date_format';
import RSVPStatus from './RSVPStatus';
import AttendanceStatus from './AttendanceStatus';

class AttendanceRowMultipleColumn extends Component {
  render() {
    const {
      attendance,
      attendance: { user },
      contentItems,
      currentSessionId,
      displayAsSearchResult = false,
      event,
      showAttendanceDropdown,
      updateAttendance,
      sessions,
      searchResultsFlag,
      isMultiSession,
    } = this.props;
    const attendanceTaken =
      event.last_session && event.last_session.attendance_taken;
    const useExpandedColumns = displayAsSearchResult && !attendanceTaken;
    const hasAssignedContentAndFlag =
      !!contentItems.length && contentItems.every(item => item.assigned_at);
    const formatDate = (date, format) =>
      moment(date, DateFormat.fixed.ISO8601_LOCAL).format(format);

    return (
      <Table.Row
        className={
          searchResultsFlag ? 'AttendanceRow' : 'AttendanceRow pl-8 pr-8'
        }
      >
        {!isMultiSession && (
          <Table.Body.Cell contentClassName="d-f fd-r">
            <div className="UserColumnCell">{user.name}</div>
            <div
              className={cn('d-f jc-sb fd-r', {
                'fg-1': !useExpandedColumns,
              })}
            >
              <div className="d-f jc-sb fd-r minw-120">
                <RSVPStatus
                  attendance={attendance}
                  event={event}
                  showAttendanceDropdown={showAttendanceDropdown}
                  updateAttendance={updateAttendance}
                  sessions={sessions}
                  isMultiSession={isMultiSession}
                />
              </div>
              {!useExpandedColumns && (
                <div className="d-f jc-sb fd-r minw-150">
                  {(attendanceTaken ||
                    attendance.created_from === 'created_manually') && (
                    <AttendanceStatus
                      sessions={sessions}
                      isMultiSession={isMultiSession}
                      attendance={attendance}
                      event={event}
                      showAttendanceDropdown={showAttendanceDropdown}
                      updateAttendance={updateAttendance}
                      hasAssignedContentAndFlag={hasAssignedContentAndFlag}
                    />
                  )}
                </div>
              )}
            </div>
          </Table.Body.Cell>
        )}
        {isMultiSession && (
          <div
            className={cn(
              `d-f jc-sb fd-r ${isMultiSession ? 'AttendanceCell' : ''}`,
              {
                'fg-1': !useExpandedColumns,
              },
            )}
          >
            <Table.Body.Cell>
              <div>{user.name}</div>
            </Table.Body.Cell>
            <Table.Body.Cell>
              <div className="d-f jc-sb fd-r minw-120">
                <RSVPStatus
                  sessions={sessions}
                  isMultiSession={isMultiSession}
                  attendance={attendance}
                  event={event}
                  showAttendanceDropdown={showAttendanceDropdown}
                  updateAttendance={updateAttendance}
                />
              </div>
            </Table.Body.Cell>
            {!currentSessionId && (
              <Table.Body.Cell>
                <div>
                  {!attendance.session_id && <div>-</div>}
                  {attendance.session_id && (
                    <LinkButton type="" className="u-linkBtn" onClick>
                      {moment(
                        localTime(
                          sessions.find(
                            session => session.id === attendance.session_id,
                          ).start_time,
                        ),
                        DateFormat.fixed.ISO8601_LOCAL,
                      ).format(DateFormat.fixed.SHORT_DAY_WITH_SHORT_MONTH)}
                      ,&nbsp;
                      {formatDate(
                        localTime(
                          sessions.find(
                            session => session.id === attendance.session_id,
                          ).start_time,
                        ),
                        DateFormat.TIME,
                      )}{' '}
                      {localTimeZone()}
                    </LinkButton>
                  )}
                </div>
              </Table.Body.Cell>
            )}
            <Table.Body.Cell>
              {!useExpandedColumns && (
                <div className="d-f jc-sb fd-r minw-150">
                  {(attendanceTaken ||
                    attendance.created_from === 'created_manually') && (
                    <AttendanceStatus
                      sessions={sessions}
                      isMultiSession={isMultiSession}
                      attendance={attendance}
                      event={event}
                      showAttendanceDropdown={showAttendanceDropdown}
                      updateAttendance={updateAttendance}
                      hasAssignedContentAndFlag={hasAssignedContentAndFlag}
                    />
                  )}
                </div>
              )}
            </Table.Body.Cell>
          </div>
        )}
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  event: state.event,
  showAttendanceDropdown: !state.event.is_archived,
  contentItems: state.associatedContent.contentItems,
});

export default connect(mapStateToProps)(AttendanceRowMultipleColumn);
